<oui-document-viewer
  class="slide-panel-viewer"
  [documentUrl]="fileUrls()"
  [filenames]="filenames()"
  [showControls]="true">
  <div oui-document-controls>
    <div class="signataire-details-container flex-vertical">
      <div class="border-bottom flex-vertical gap-24 padding-24">
        <div class="flex-horizontal flex-center justify-space-between gap-24">
          <h5>Suivi signature</h5>
          <oui-button
            type="icon"
            color="secondary"
            (click)="signaturePanelService.closePanel()">
            <oui-icon>close</oui-icon>
          </oui-button>
        </div>
        <div class="gap-4 flex-vertical">
          @if (!isMultipleFiles()) {
            <div class="subtitle-1">{{ firstFile().fileName }}</div>
          }
          <div class="body-2 color-on-surface-medium">
            Envoyé en signature le {{ firstFile().dateDeCreation | date: 'dd/MM/yyyy à HH:mm' }}
          </div>
        </div>
        <oui-button
          type="outlined"
          (click)="downloadDocument()">
          @if (isMultipleFiles()) {
            Télécharger les documents
          } @else {
            Télécharger le document
          }
        </oui-button>
        <div class="flex-horizontal flex-center gap-16">
          <div class="width-100-pc flex-vertical gap-4">
            @if (firstFile().signatureStates?.requestStatus === signatureRequestStatus.Failure) {
              <div class="flex-horizontal gap-8 max-width-300 flex-center">
                <oui-icon class="color-alert"> warning </oui-icon>
                <div class="color-alert">La récupération de l'état des signataires est temporairemnt indisponible pour cette signature</div>
              </div>
            } @else if (firstFile().signatureStates?.requestStatus === signatureRequestStatus.NotFound) {
              <div class="flex-horizontal gap-8 max-width-300 flex-center">
                <oui-icon class="color-error"> error </oui-icon>
                <div class="color-error">L'envoi en signature a échoué, veuillez recommencer</div>
              </div>
            } @else if (
              firstFile().etatSignature === signatureStateEnum.Pending || firstFile().etatSignature === signatureStateEnum.Completed
            ) {
              <div class="caption">Signatures {{ getTotalSigned() }} / {{ firstFile().signatureStates?.states?.length ?? 0 }}</div>
              <oui-progress-bar
                color="accent"
                mode="determinate"
                [value]="getSignaturePercent()">
              </oui-progress-bar>
            }
          </div>

          <lib-status-tag
            [status]="firstFile().etatSignature"
            [enumType]="'document'"
            [size]="'big'">
          </lib-status-tag>
        </div>
        @if (firstFile().etatSignature === signatureStateEnum.Pending) {
          <oui-button
            type="contained"
            color="primary"
            [disabled]="isReadOnly() || !canCancelSignature()"
            (click)="cancelSignature()">
            @if (!canCancelSignature()) {
              <oui-loading size="xs"></oui-loading>
            } @else {
              Annuler la signature
            }
          </oui-button>
        }
      </div>
      <div class="flex-vertical padding-24 gap-24">
        @for (signataire of firstFile().signatureStates?.states; track signataire.email) {
          <div class="flex-horizontal justify-space-between gap-8">
            <div class="flex-horizontal gap-8">
              <div>
                @switch (signataire.signatureState) {
                  @case (signerStatusEnum.Signed) {
                    <oui-icon
                      class="color-valid"
                      [fill]="true">
                      check_circle
                    </oui-icon>
                  }
                  @case (signerStatusEnum.Failed || signerStatusEnum.Canceled) {
                    <oui-icon
                      class="color-error"
                      [fill]="true">
                      cancel
                    </oui-icon>
                  }
                  @default {
                    <oui-icon>radio_button_unchecked</oui-icon>
                  }
                }
              </div>
              <div>
                <div class="body-2 color-on-surface-medium">
                  {{
                    signataire.type === signataireTypeEnum.Consultant
                      ? 'Consultant'
                      : signataire.type === signataireTypeEnum.Investisseur
                        ? 'Investisseur'
                        : ''
                  }}
                </div>
                <div class="body-1 padding-vertical-4">{{ signataire.lastName }} {{ signataire.firstName }}</div>
                <div class="caption color-on-surface-medium">{{ signataire.email }}</div>
              </div>
            </div>
            <div class="flex-vertical flex-end">
              <lib-status-tag
                [status]="signataire.signatureState"
                [enumType]="'signature'"
                [size]="'big'">
              </lib-status-tag>
              <div class="caption color-on-surface-medium text-end status-caption">
                @switch (signataire.signatureState) {
                  @case (signerStatusEnum.Signed) {
                    le {{ signataire.actionDate | date: 'dd/MM/yyyy à HH:mm' }}
                  }
                  @case (signerStatusEnum.Waiting) {
                    de la signature du précédent signataire
                  }
                  @case (signerStatusEnum.CodeSent) {
                    Code de vérification envoyé par SMS
                  }
                }
              </div>
            </div>
          </div>
          @if (relanceSignerStatus.includes(signataire.signatureState)) {
            <oui-button
              type="outlined"
              color="primary"
              [disabled]="isReadOnly()"
              (click)="relanceSignature()">
              Relancer le signataire
            </oui-button>
          }
        }
      </div>
    </div>
  </div>
</oui-document-viewer>
